<template>
  <VendorBasicPage
    main-class="overflow-x-hide overflow-y-hide"
    body-class="tw-flex tw-items-center tw-justify-center tw-h-[100%]"
  >
    <div class="col-md-12 flex-container">
      <BrandPattern2 page="LOGIN" class-name="automation" />
    </div>
    <div
      class="tw-bg-white tw-w-[630px] tw-rounded-[6px] box-shadow-contain tw-px-[20px] sm:tw-px-[55px] sm:tw-pt-[62.66px] tw-pb-[55.45px] lg:tw-pl-[70px] lg:tw-pr-[55px] tw-z-[1] contain-responsive"
      data-cy="thank-you-submitting-assessment-modal"
    >
      <p
        class="tw-w-[405px] tw-text-[#0345BD] tw-text-[26px] tw-font-semibold tw-mb-[24px] title-responsive"
      >
        {{
          getComponentUiText(
            "app-vendor-assessment-external-submit-modal-title-1",
          )
        }}
      </p>
      <p
        class="tw-text-[#231F20] tw-text-[15px] tw-font-normal tw-leading-[145%] content-responsive"
      >
        {{
          getComponentUiText(
            "app-vendor-assessment-external-submit-modal-content-1",
            false,
            passedData,
          )
        }}
      </p>
      <div class="tw-w-full tw-flex tw-justify-end tw-mt-[28px]">
        <button
          type="button"
          class="tw-w-[108px] tw-h-[45px] tw-bg-[#0345BD] tw-border-[#0345BD] btn btn-primary letsgo-button tw-rounded-[30px] box-shafow-button tw-text-center tw-text-[18px] tw-font-semibold button-responsive"
          data-cy="close-btn"
          tabindex="3"
          @click="close"
        >
          {{
            getComponentUiText(
              "app-assess-recommendations-action-table-bulk-actions-modal-button-add-no-action-1",
            ).toUpperCase()
          }}
        </button>
      </div>
    </div>
  </VendorBasicPage>
</template>

<script setup lang="ts">
import BrandPattern2 from "@/components/prospect/brandPattern/brandPattern2.vue";
import VendorBasicPage from "./vendorBasicPage.vue";
import { onBeforeUnmount, ref } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import router from "@/router";

const passedData = ref(router.currentRoute.value.query);

const close = () => {
  window.location.href = "https://cybersystem.io/";
};

const beforeUnmount = () => {
  if (document.body.classList.contains("page-opacity")) {
    document.body.classList.remove("page-opacity", "page-bg", "page-shadow");
  }
};

onBeforeUnmount(() => {
  beforeUnmount();
});
</script>

<style lang="scss" scoped>
.flex-container {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: calc(100vh - 56px);
}

.automation {
  top: 0px !important;
  height: 100% !important;
}

.box-shadow-contain {
  box-shadow: 2px 0px 20px 0px rgba(33, 31, 88, 0.1);
}

.box-shafow-button {
  box-shadow: 0px 2px 4px 0px rgba(33, 31, 88, 0.25);
}

@media (max-width: 767px) {
  .contain-responsive {
    width: auto !important;
    height: auto !important;
    padding: 20px;
  }
  .title-responsive {
    width: 100%;
    font-size: 24px;
  }
  .content-responsive {
    width: 100%;
    font-size: 14px;
  }
  .button-responsive {
    width: 80px;
    height: 45px;
    font-size: 16px;
    padding: 5px 10px;
  }
}

@media (max-width: 600px) {
  .contain-responsive {
    width: auto !important;
    height: auto !important;
    position: absolute;
    margin: 0 20px;
  }
  .title-responsive {
    width: 100%;
    font-size: 20px;
  }
  .content-responsive {
    width: 100%;
    font-size: 12px;
  }
  .button-responsive {
    width: 70px;
    height: 35px;
    font-size: 14px;
    padding: 5px 10px;
  }
}
</style>
